export const CURRENT_CONDITIONS_WIDGET_VIEW_OPTIONS = Object.freeze([
  Object.freeze({ value: 'map', label: 'Map' }),
  Object.freeze({ value: 'nearby', label: 'Nearby' }),
]);
